import getRoundsWorkoutSectionUtil from '../../../model/utils/get-rounds'
import isCircuitWorkoutSectionUtil from '../../../model/utils/is-circuit'
import getCurrentWorkoutSectionSelect from '../get-current'
import getCurrentWorkoutExercisesWorkoutSectionSelect from '../get-current-workout-exercises'
import { createSelector } from 'reselect'

const getCircuitRoundsWorkoutSectionSelector = createSelector(
  getCurrentWorkoutSectionSelect,
  getCurrentWorkoutExercisesWorkoutSectionSelect,
  (instance, workoutExercises) => {
    if (!isCircuitWorkoutSectionUtil(instance)) {
      return
    }
    return getRoundsWorkoutSectionUtil(workoutExercises)
  }
)

const hasCircuitRoundsWorkoutSectionSelector = createSelector(getCircuitRoundsWorkoutSectionSelector,
  (rounds) => {
    return !!(
      rounds && rounds.length
    )
  }
)

export {
  getCircuitRoundsWorkoutSectionSelector,
  hasCircuitRoundsWorkoutSectionSelector
}
